<template>
    <cart-item-base
        :item="item"
        :readonly="readonly"
    >
        <template slot-scope="{ removeItem, updateQuantity }">
            <tr>
                <td class="article article-left">
                    <a :href="item.url" :title="item.name">
                        <div class="article-media">
                            <responsive-image :media="item.coverImage" :alt="item.name" classes="article-media"></responsive-image>
                        </div>
                        <div class="article-header">
                            <h3 class="article-title">{{ item.name }}</h3>
                            <div class="text">
                                <p class="mb-0">{{ __('méret: :size; szín: :color', {size: item.size, color: item.color + (item.color2 ? ' - ' + item.color2 : '') + (item.pattern ? ' - ' + item.pattern : '')  }) }} </p>
                                <p class="mb-0">{{ __('Cikkszám') }}: {{ item.basicCode }}</p>
                            </div>
                        </div>
                    </a>
                </td>
                <td :data-lang-content="__('Ár')">{{ item.originalPrice | currency(currencyFormat(item.currency)) }}</td>
                <td :data-lang-content="__('Kedvezményes ár')">
                    {{ (item.totalPrice.gross / item.quantity) | currency(currencyFormat(item.currency)) }}
                    <span
                        v-if="item.loyaltyDiscount"
                        class="loyalty-price">
                        <strong style="font-size: 110%;"> {{ item.loyaltyDiscount }}%</strong>
                        {{ __('Törzsvásárlói kedvezmény')}}
                    </span>
                </td>

                <td :data-lang-content="__('Darab')" class="flex amount-wrap items-center justify-center">
                    <a href="#" @click.stop="decrementQuantity" class="remove-item">
                        <svg class="icon" :aria-label="__('Tétel törlése')">
                            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-minus"></use>
                        </svg>
                    </a>
                    <input type="text" class="30656_qtyinp" @change="updateQuantity" :value="item.quantity" >
                    <a href="#" @click.stop="incrementQuantity" class="remove-item">
                        <svg class="icon" :aria-label="__('Tétel hozzáadása')">
                            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-plus"></use>
                        </svg>
                    </a>
                </td>
                <td :data-lang-content="__('Összesen')">
            <span class="value cc-subtotal total">
                {{ item.totalPrice.gross | currency(currencyFormat(item.currency)) }}
                </span>
                </td>
                <td :data-lang-content="__('Törlés')" class="col-remove">
                    <a href="#" @click="$loading.show(); removeItem()" class="remove-item">
                        <svg class="icon" :aria-label="__('Tétel törlése')">
                            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-close"></use>
                        </svg>
                    </a>
                </td>
            </tr>
        </template>
    </cart-item-base>
</template>

<script>
import modifiesQuantity from '../../mixins/modifiesQuantity'
import currencyFormatter from '../../mixins/currencyFormatter';

export default {
    name: 'CartItem',
    mixins: [modifiesQuantity, currencyFormatter],

    props: {
        item: {
            type: Object,
            required: true
        },

        readonly: {
            type: Boolean,
            default: false
        },
    }
}
</script>
